import React from 'react';
import { AlertProvider } from 'acma-spa';
import { Link } from '../../common/FormHelpers';
import { ClientApiProps } from '../../../client/common/ClientApiProps';

const wrapperStyle: React.CSSProperties = { display: 'inline-flex', flexDirection: 'column', gap: '1rem' };

/**
 * NOTE: Wrap everything in an inline-flex. It behaves just like a series of "p" tags, without breaking HTML strict guidelines.
 * We can't use "p" tags because the AlertProvider already wraps everything in a "p" tag. A "p" tag can not wrap a block-level element.
 */
export function PrivacyDeclaration(props: ClientApiProps): JSX.Element {
  const msg = (
    <>
      <div className="alert alert-info">
        <p>
          The personal information being collected in this form is to enable the ACMA to decide whether it will assign you the call sign you have applied for
          consistent with the {Link(props.contentUrls.examRules, 'Radiocommunications (Amateur Stations) Class Licence 2023')}. The information will also be used by the ACMA to administer call signs
          and facilitate call sign applications and assignments.
        </p>
        <p>
          The ACMA publishes a call sign register on its website that lists all call signs and, if the call sign is allocated, the respective qualification level
          associated with the allocated call sign. The call sign register does not contain any other information about a licence holder.
        </p>
        <p>
          The ACMA will not use any of the personal information you provide in this form for any other purpose, nor will we disclose it, unless we have your
          consent or we are otherwise permitted to do so under the <em>Privacy Act 1988</em>.
        </p>
        <p>
          Further information about the {Link(props.contentUrls.privacyPolicy, "Privacy Act and the ACMA's Privacy Policy")} is on our website. The
          Privacy Policy contains details about how you may access personal information about you that is held by the ACMA, and seek the correction of such
          information. It also explains how you may complain about a breach of the {Link(props.contentUrls.privacyAct, 'Privacy Act')} and how we will deal with
          such a complaint.
        </p>
      </div>
    </>
  );

  return msg //<AlertProvider title="Privacy" color="info" messages={[msg]} />;
}
